import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import marinatedChickenData from "./marinated-chicken-data";
import Product from "../../components/Product/Product";
import OverlayCard from "../../components/OverlayCard/OverlayCard";
import FeatureCard from "../../components/FeatureCard/FeatureCard";
import HeroSection from "../../components/HeroSection/HeroSection";
import FeatureTextSection from "../../components/FeatureTextSection/FeatureTextSection";

const MarinatedChickenPage = () => {
  const [products, setProducts] = useState([]);
  const [heroSection, setHeroSection] = useState({});
  const [featureCardsInfo, setFeatureCardsInfo] = useState([]);
  const [textSection, setTextSection] = useState({});
  const [feature_text_section, setFeatureTextSection] = useState({});
  const [OverlayCards, setOverlayCards] = useState([]);
  const [why_choose_section, setWhyChooseSection] = useState({});
  useEffect(() => {
    setProducts(marinatedChickenData.products);
    setHeroSection(marinatedChickenData.hero_section);
    setTextSection(marinatedChickenData.text_section);
    setFeatureTextSection(marinatedChickenData.feature_text_section);
    setFeatureCardsInfo(marinatedChickenData.feature_cards_info_card);
    setOverlayCards(marinatedChickenData.overlay_card);
    setWhyChooseSection(marinatedChickenData.why_choose_section);
  }, []);

  return (
    <div className="marinated-chicken-page">
      <HeroSection
        title={heroSection.title}
        description={heroSection.description}
        video={heroSection.src}
      />

      <section className="catalog-section">
        <h2 className="text-4xl md:text-5xl font-extrabold mt-12 mb-3 text-[#2c3e50]">Our Products</h2>
        <div className="mx-auto px-6 max-w-screen-xl">
          <Row gutter={16} className="flex flex-wrap justify-center">
            {products.map((product) => (
              <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8} key={product.id}>
                <Product product={product} />
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="text-section text-[#2c3e50]">
        <FeatureTextSection
          title={textSection.title}
          description={textSection.description}
        />
      </section>

      <section className="feature-text-section justify-center text-[#2c3e50]">
        <FeatureTextSection
          title={feature_text_section.title}
          subline={feature_text_section.subline}
          description={feature_text_section.description}
          className={"bg-gray-100 py-20"}
        />
      </section>

      <section className="features-card-info-section bg-gray-100 text-[#2c3e50]">
        <div className="w-3/4 mx-auto">
          <Row gutter={16} className="flex flex-wrap justify-center">
            {featureCardsInfo.map((feature, idx) => (
              <Col xs={24} sm={12} md={8} lg={8} key={idx} className="gap-4">
                <FeatureCard feature={feature} customClassName="bg-white" />
              </Col>
            ))}
          </Row>
          <div className="text-center pb-12 w-1/2 w-max-1/2 mx-auto">
            <p className="text-center text-2xl md:text-3xl pt-12">
              Available in a variety of cuts and spice levels to suit every menu
              and customer preference.
            </p>
          </div>
        </div>
      </section>

      <section className="why-choose-section bg-gray-100 text-[#2c3e50]">
        <FeatureTextSection
          title={why_choose_section.title}
          description={why_choose_section.description}
        />

        <div className="w-5/6 mx-auto">
          <Row gutter={16} className="w-full p-2">
            {OverlayCards.map((card, idx) => (
              <Col xs={24} sm={24} md={12} lg={6} key={idx}>
                <OverlayCard
                  title={card.title}
                  subtitle={card.description}
                  image={`/media/${card.image}`}
                />
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </div>
  );
};

export default MarinatedChickenPage;
